import PropTypes from 'prop-types';
import React from 'react';

import { useFormContext } from 'react-hook-form';

import InputFieldText from 'components/form/inputFields/InputFieldText/InputFieldText';

const ContentElementHirePosition = ({ index = 0 }) => {
  const name = 'position';
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <InputFieldText
      id={`${name}${index}`}
      {...register(name, {
        required: {
          value: true,
          message: 'Please provide the position of the hire',
        },
      })}
      testId="company-content-hire-inputPositon"
      errors={errors}
      placeholder="Type the position of the hire..."
    >
      <InputFieldText.Label>Job position*</InputFieldText.Label>
    </InputFieldText>
  );
};

ContentElementHirePosition.propTypes = {
  index: PropTypes.number,
};

export default ContentElementHirePosition;
